import moment from 'moment'

import { dateDifference } from 'lib/datetime/dateUtils'
import { DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'
import { pluralizeToString } from 'lib/string/pluralize'

export interface TourV2DepartureDetails {
  daysCount: string
  endDateWeekday: string
  formattedEndDate: string
  formattedStartDate: string
  startDateWeekday: string
}

function extractTourV2DepartureDetails(departure: Tours.TourV2OfferDeparture): TourV2DepartureDetails {
  const startDateMoment = moment(departure.startDate)
  const formattedStartDate = startDateMoment.format(DMY_CASUAL_SHORT_FORMAT)
  const startDateWeekday = startDateMoment.format('dddd')

  const endDateMoment = moment(departure.endDate)
  const formattedEndDate = endDateMoment.format(DMY_CASUAL_SHORT_FORMAT)
  const endDateWeekday = endDateMoment.format('dddd')

  const { days } = dateDifference(new Date(departure.endDate), new Date(departure.startDate))

  return {
    daysCount: pluralizeToString('day', days + 1),
    endDateWeekday,
    formattedEndDate,
    formattedStartDate,
    startDateWeekday,
  }
}

export default extractTourV2DepartureDetails
